<template>
  <div class="CollectAcritle">
    <p class="acritleNumber">{{$t('collect.共')}}{{ index }}{{$t('collect.篇文章')}}</p>
    <div class="actile-card" v-for="(item, i) in list" :key="i">
      <div class="left">
        <router-link target="_blank" :to="`/article/detail/${item.id}`">
          <h4>{{ item.title }}</h4>
          <p v-html="delStyleTag(item.content)"></p>
        </router-link>
        <div class="info" :class="{ userType2: item.userType === 2 && item.isCertification === 1 }">
          <router-link target="_blank" :to="`/peopleCenter/${item.userId}`">
            <img
              :src="
                item.userAvatar
                  | imageUrl('/static/profile_img_default.png', 60, 60)
              "
              alt
            />
            <span class="nickname">{{ item.userNickName }}</span>
          </router-link>
          <div class="createTime">
            <!-- <img src="/static/v2/article/view_icon.png" />
          <span class="view">{{item.viewCount || 0}}</span> -->
            <span class="time">{{
              item.articleReleaseTime | dateToNow(language)
            }}</span>
          </div>
        </div>
      </div>
      <div class="right" v-if="image(item)">
        <img :src="image(item) | imageUrl('', 356, 200, '', 'gif')" alt />
      </div>
      <div>
        <el-popover placement="bottom" trigger="hover">
          <div class="operationTitle">
            <p class="title1" @click="closeVideo(item.id)">{{$t('collect.取消收藏')}}</p>
          </div>
          <span class="operation" slot="reference"
            ><img src="/static/collect/icon_playlist_video_dots@2x.png" alt=""
          /></span>
        </el-popover>
      </div>
    </div>
    <div class="createPop" v-if="cleateLookPop">
      <div class="popBox popBox1">
        <p class="popTitle">
          <span class="title1">{{$t('collect.取消收藏')}}</span>
        </p>
        <p class="textTitle">{{$t('collect.是否取消收藏该视频？')}}</p>
        <div class="buttom1 buttom2">
          <div class="butBox">
            <span class="cel" @click="closeLook">{{$t('collect.是')}}</span
            ><span class="cir" @click="cleateLookPop = false">{{$t('collect.否')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CollectAcritle",
  props: ["list", "index"],
  data() {
    return {
      cleateLookPop: false,
    };
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  methods: {
    closeLook(id) {
      let params = {
        topicQuestionId: id,
        type: 1,
      };
      this.$http.post("/api/u/topicquestion/like", params).then((res) => {
        this.$message.success(res.message);
        this.$emit("getList");
        this.cleateLookPop = false;
      });
    },
    closeVideo(id) {
      // this.cleateLookPop = true;
      // this.videoId = id;
      this.closeLook(id);
    },
    image(item) {
      let src = "";
      const imageList = item.content.match(/<img[^>]*>/);
      if (imageList && imageList.length) {
        imageList[0].replace(/ src="([^"]*)"/, (a, b) => (src = b));
      }
      return src;
    },
    delStyleTag(str) {
      return str
        .replace(/<style((?!<\/style>).)*<\/style>/g, "")
        .replace(/<style((?!<\/style>).)*<\/style>/g, "")
        .replace(/<[^>]+>/g, "");
    },
    myCenter() {
      this.$router.push(`/peopleCenter/${this.item.userId}`);
    },
  },
};
</script>
<style>
/* .el-popover {
  min-width: auto;
  padding: 10px 0;
} */
.operationTitle .title1 {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  text-align: center;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  cursor: pointer;
}
.operationTitle .title1:hover {
  background: #f5f5f5;
}
</style>
<style lang="stylus" scoped>
.CollectAcritle {
  padding: 0 47px 50px;

  .acritleNumber {
    height: 23px;
    font-size: 15px;
    font-weight: 400;
    color: #999999;
    line-height: 23px;
    margin-bottom: 30px;
  }

  .actile-card {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    height: 163px;
    padding: 25px 0 20px 0;
    border-bottom: 1px solid rgba(235, 235, 235, 1);
    box-sizing: border-box;
    position: relative;

    .left {
      flex: 1;
      max-width: 800px;

      a {
        h4 {
          height: 23px;
          font-size: 16px;
          font-weight: 600;
          color: #0A0A0A;
          line-height: 22px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 540px;
        }

        &>p {
          height: 40px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-word;
          margin: 12px 0;
        }
      }

      div.info {
        display: flex;
        flex-direction: row;
        align-items: center;

        a {
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;

          &.userType2::before {
            content: '';
            left: 20px;
            bottom: 0;
            position: absolute;
            width: 10px;
            height: 10px;
            background: url('/static/v2/match/Verified_icon_blue_20.png');
            background-size: 10px;
          }

          img {
            width: 28px;
            height: 28px;
            border-radius: 14px;
            margin-right: 8px;
            border: 1px solid #f5f5f5;
          }

          .nickname {
            font-size: 12px;
            color: #333;

            &:hover {
              color: #0A0A0A;
            }
          }
        }

        .createTime {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding-left: 30px;
          font-size: 12px;

          span {
            color: #B8B8B8;
            padding-right: 20px;
          }

          img {
            width: 18px;
            height: 12px;
            margin-right: 4px;
          }
        }
      }
    }

    .right {
      width: 178px;
      margin-left: 12px;

      img {
        width: 178px;
        height: 100px;
      }
    }

    .operation {
      position: absolute;
      right: 0;
      bottom: 8px;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}

.createPop {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;

  .popBox {
    width: 445px;
    height: 362px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .popTitle {
      height: 60px;
      line-height: 60px;
      padding-left: 24px;
      box-sizing: border-box;
      position: relative;
      border-bottom: 1px solid #E0E0E0;

      .title1 {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        margin-right: 16px;
      }

      .title2 {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
      }

      .close {
        position: absolute;
        right: 24px;
      }
    }

    .from1 {
      padding: 20px 24px 0;
      height: 230px;
      box-sizing: border-box;
      overflow-y: scroll;

      .nameBox {
        margin-bottom: 16px;
        cursor: pointer;
        font-size: 15px;
        font-weight: 400;
        color: #333333;
      }
    }

    .buttom1 {
      border-top: 1px solid #E0E0E0;
      height: 70px;
      padding: 20px 24px;
      box-sizing: border-box;
      text-align: center;

      .create {
        float: left;
        font-size: 15px;
        font-weight: 400;
        color: #3664ED;
        cursor: pointer;
      }

      .butBox {
        .cel {
          width: 90px;
          height: 30px;
          border: 1px solid #999999;
          box-sizing: border-box;
          line-height: 30px;
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
          margin-right: 20px;
          cursor: pointer;
        }

        .cir {
          width: 90px;
          height: 30px;
          background: #2026CC;
          line-height: 30px;
          font-size: 14px;
          font-weight: 600;
          color: #FFFFFF;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
          cursor: pointer;
        }
      }
    }
  }

  .popBox1 {
    height: 220px;
    width: 380px;

    .textTitle {
      height: 24px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
      text-align: center;
      margin: 27px 0 32px 0;
    }

    .buttom2 {
      border-top: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collect/CollectAcritle.vue